<template>
  <div
    id="app"
    v-loading="$store.state.api_loading"
    body
    fullscreen
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  background-color: rgb(249, 249, 249);
}
/* 让单词可以断行换行 */
* {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.el-table th,
.el-table td {
  white-space: normal !important; /* 取消不换行 */
  word-break: break-word !important; /* 允许单词内换行 */
  overflow-wrap: break-word !important; /* 更现代的写法，兼容 word-wrap */
}
.el-form-item__tip {
  line-height: 23px !important;
  margin-top: 5px !important;
}
</style>
